module.exports = __webpack_public_path__ + "fonts/2499eb7.woff";